/**
 * WHO-6344: the member's 30-day web session lives in an httpOnly cookie that
 * page scripts cannot read. The page holds only 5-minute browser tokens,
 * minted from it by `/api/session/token`.
 */
export const SESSION_COOKIE = "__Host-wh_session";
/** Readable marker so the page knows a session exists. Carries no secret. */
export const SIGNED_IN_COOKIE = "wh_signed_in";
/** The pre-WHO-6344 JS-readable cookie. Read once to migrate, then cleared. */
export const LEGACY_TOKEN_COOKIE = "token";

/**
 * The member token for server-side gateway calls (SSR, API routes): the
 * session cookie, else a not-yet-migrated legacy cookie. Never send it to the page.
 */
export const readSessionToken = (
  cookies: Partial<Record<string, string>>
): string | undefined =>
  cookies[SESSION_COOKIE] || cookies[LEGACY_TOKEN_COOKIE] || undefined;

export const hasSession = (cookies: Partial<Record<string, string>>) =>
  !!readSessionToken(cookies);
